<template>
  <section class="notifications card navbar-notifications">
    <header class="cardHeader card-header">
      <div class="text-center mb-sm">
        <strong>You have {{notificationsCount || 0}} notifications</strong>
      </div>
      <b-button-group id="notification-b-buttons">
        <!--
        <b-button variant="default" @click="changeNotificationsTab(1)">Notifications</b-button>        
        <b-button variant="default" @click="changeNotificationsTab(2)">Messages</b-button>
        <b-button variant="default" @click="changeNotificationsTab(3)">Progress</b-button>
        -->
      </b-button-group>
    </header>
    <!-- <NewNotifictionsList v-if="newNotifications" /> -->
    <NotifictionsList v-if="notificationsTabSelected === 1" />
    <Messages v-else-if="notificationsTabSelected === 2" />
    <Progress v-else-if="notificationsTabSelected === 3" />
    <NotifictionsList v-else/>
    <footer class="cardFooter text-sm card-footer">
      
      <b-button
        variant="link"
        @click="markNotificationsAsRead"
        :class="{disabled: isLoad, 'btnNotificationsReload btn-xs float-right py-0': true}"
        v-if="notificationsCount > 0"
      >
        <span v-if="isLoad"><i class="la la-refresh la-spin" />...</span>
        <i v-else class="la la-check" /> &nbsp;
        <span class="fs-mini">Mark All as Read</span>
      </b-button>
    </footer>
  </section>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapState, mapActions} from 'vuex';
import NotifictionsList from './NotificationsDemo/NotificationsList';
import NewNotifictionsList from './NotificationsDemo/NewNotificationsList';
import Messages from './NotificationsDemo/Messages';
import Progress from './NotificationsDemo/Progress';
import _ from 'lodash';
import moment from 'moment-timezone';

export default {
  name: 'Notification',
  components: {
    NotifictionsList, NewNotifictionsList, Messages, Progress,
  },
  data() {
    return {
      notificationsTabSelected: 1,
      newNotifications: null,
      isLoad: false,
    };
  },
  methods: {
    ...mapActions('notifications', ['markAllNotificationsAsRead', 'deleteNotifications']),
    
    changeNotificationsTab(tab) {
      Vue.set(this, 'notificationsTabSelected', tab);
      Vue.set(this, 'newNotifications', null);
    },
    loadNotifications() {
      Vue.set(this, 'isLoad', true);

      setTimeout(() => {
        Vue.set(this, 'newNotifications', 'new notifications component');
        Vue.set(this, 'isLoad', false);
      }, 1500);
    },
    
    async markNotificationsAsRead() {
      Vue.set(this, 'isLoad', true);
      await this.markAllNotificationsAsRead({employeeID: this.userID});
      // await this.deleteNotifications({employeeID: this.userID});
      Vue.set(this, 'isLoad', false);

      /*
      setTimeout(() => {
        Vue.set(this, 'newNotifications', 'new notifications component');
        Vue.set(this, 'isLoad', false);
      }, 1500);
      */
    }
  },

  computed: {
    ...mapGetters({
      notificationsCount: "notifications/count",
      //notificationsLastCleared: "notifications/lastCleared",
      allMyTasksDueToday: "tasks/allMyTasksDueToday"
    }),
    ...mapState({
        notifications: state => state.notifications.notifications,
        userID: state => state.customer.userID,
        siteID: state => state.customer.siteID,
        settings: state => state.customer.settings,
        notificationsLastCleared: state => state.notifications.notificationsLastCleared
    }),

    allSettings() {
      if(this.settings)
        return _.keyBy(this.settings, 'Property');
    },

  },

};
</script>

<style src="./Notifications.scss" lang="scss" />